import React from 'react';

export default function Label({ isVisible, title, value }) {
  if (!isVisible) {
    return null;
  }

  return (
    <div className="flex gap-1 items-center">
      <h3 className="text-sm font-bold text-slate-800 dark:text-slate-100">
        {title}:
      </h3>
      <span className="text-sm font-normal">{value}</span>
    </div>
  );
}
